import React from 'react';
import { Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { showDSGVOBanner } from '@kitconcept/volto-dsgvo-banner/actions';
import { cookieBannerMessages as messages } from '../../../../../components/CookieBanner/cookieBannerMessages';

const DsgvoBlockView = ({ showDSGVOBanner: openPreferences }) => {
  const intl = useIntl();

  return (
    <div className="csj-dsgvo-block-cta">
      <Button
        type="button"
        className="csj-cookie-banner__btn csj-cookie-banner__btn--primary"
        onClick={openPreferences}
      >
        {intl.formatMessage(messages.configure)}
      </Button>
    </div>
  );
};

export default connect(null, { showDSGVOBanner })(DsgvoBlockView);
